import { render, staticRenderFns } from "./document4.vue?vue&type=template&id=190a297d&"
import script from "./document4.vue?vue&type=script&lang=ts&"
export * from "./document4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports